import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import * as styles from '../../../config/styles'

import useUserManagement from '../../../hooks/useUserManagement'
import useAuthentication from '../../../hooks/useAuthentication'

const UserSelect = ({
    name,
    projectId,
    required,
    requiredRole,
    onChange,
    value,
    label,
    disabled,
}) => {
    const requiredClassname = required ? 'required' : ''
    const { currentUser } = useAuthentication();
    const {
        getUserFromID,
        activeUsers,
        userHasExplicitProjectAccess,
        userHasRole,
    } = useUserManagement()
    const [values, setValues] = useState([])
    const [infoMessage, setInfoMessage] = useState("")
    
    useEffect(() => {
        if (disabled) {
            // Special case this.. If it's disabled, it's ok that it's not an active user
            const user = getUserFromID(value)
            setValues([ user ])
            return
        }

        const list = activeUsers
            .filter(listUser => {
                // If it's current, the list might possibly not be up to date yet
                const user = listUser.id === currentUser.id ? currentUser : listUser
                const hasExplicitAccess = userHasExplicitProjectAccess(user, projectId)
                const hasRole = userHasRole(user, requiredRole)

                // Show users with explicit project access AND required role
                if (projectId && requiredRole) {
                    return hasExplicitAccess && hasRole
                }

                // Show users with explicit project access
                if (projectId) {
                    return hasExplicitAccess
                }

                // Show users with required role
                if (requiredRole) {
                    return hasRole
                }

                return true
            })
        const emptyOption = !required ? [{ value: 0, label: '' }] : []
        setValues([...emptyOption, ...list])

        if (value === null || value === 0 || list.length === 0)
            return
        
        // If selected user is not in the list, clear the value!
        const included = list.some(item => item.id === value)
        if( !included ) {
            const user = getUserFromID(value)
            if (required) {
                if (userHasRole(user, "full_access_admin")) {
                    // Stupid special case for SuperAdmin. We must get rid of this shit.
                    setInfoMessage("Super Admin must be a member of this library to be an owner.")
                } else {
                    setInfoMessage("Previous owner <strong>" + user.label + "</strong> is no longer a member of this library.")
                }
            }
            // This is very bad, but if I set it straight away,
            // it gets overwritten in the parent by the effect
            // setting it from the server load.
            // For some reason that re-set doesn't trigger this effect.
            // TODO fix this in some sane way.
            // In the meantime. Fuck it - Oct 2025
            setTimeout(() => onChange(null), 100)
        }
    }, [disabled, value, activeUsers])

    return (
        <div className="form-group">
            <span>
                <label className={`col-sm-2 control-label ${requiredClassname}`}>{label}</label>
            </span>
            <div className="col-sm-8">
                <Select
                    key={name}
                    name={name}
                    value={values.filter(option => option.value === value)}
                    onChange={value => onChange(value.value) }
                    options={values}
                    placeholder="Select..."
                    isMulti={false}
                    styles={styles.singleSelect}
                    noOptionsMessage={() => 'No results found'}
                    backspaceRemovesValue={false}
                    isDisabled={disabled}
                />
                <span className="help-block m-b-none m-t-none">
                    <small className="form-info-text" dangerouslySetInnerHTML={{__html: infoMessage}}></small>
                </span>
            </div>
        </div>
    )
}

export default UserSelect
